export default "__VITE_ASSET__Mf_pMPGJ__"